import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id) {
    return await api(route('api.v1.reports.index', projectId), 'get');
  },

  async show(id: Id) {
    return await api(route('api.v1.reports.show', id), 'get');
  },

  async store(projectId: Id, data: ApiRequests['api.v1.reports.store']) {
    return await api(route('api.v1.reports.store', projectId), 'post', {
      data,
      casts: {
        auto_generate_day: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        email_message: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.reports.update']) {
    return await api(route('api.v1.reports.update', id), 'put', {
      data,
      casts: {
        auto_generate_day: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        email_message: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async generate(id: Id, data: ApiRequests['api.v1.reports.generate']) {
    return await api(route('api.v1.reports.generate', id), 'post', {
      data,
      casts: {
        month: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        issue_report: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async issue(id: Id, mediaUuid: string) {
    return await api(route('api.v1.reports.issue', { report: id, media: mediaUuid }), 'post');
  },
};
